/* Keep the approved PDP markup and its native content until imported copy is available. */
(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-pdp-sheet-content]';
  if (window.SebiPdpSheetContent) {
    window.SebiPdpSheetContent.refresh(document);
    return;
  }

  const requests = new Map();
  const hydrated = new WeakSet();
  const pending = new WeakSet();

  function loadDatabase(url) {
    if (!requests.has(url)) {
      const request = fetch(url, { credentials: 'same-origin' })
        .then(response => {
          if (!response.ok) throw new Error('PDP content unavailable');
          return response.json();
        })
        .catch(error => {
          requests.delete(url);
          throw error;
        });
      requests.set(url, request);
    }
    return requests.get(url);
  }

  function updateDescription(root, description) {
    if (typeof description !== 'string' || !description.trim()) return;
    const paragraphs = description.split(/\r\n?|\n/).map(part => part.trim()).filter(Boolean);
    if (!paragraphs.length) return;

    root.querySelectorAll('[data-pdp-sheet-description]').forEach(target => {
      const fragment = document.createDocumentFragment();
      paragraphs.forEach(text => {
        const paragraph = document.createElement('p');
        paragraph.textContent = text;
        fragment.appendChild(paragraph);
      });
      target.replaceChildren(fragment);
      target.hidden = false;
    });
  }

  function updateBenefits(root, benefits) {
    if (!Array.isArray(benefits)) return;
    // Each source entry is one benefit; commas inside a claim stay intact.
    const entries = benefits.filter(item => typeof item === 'string').map(item => item.trim()).filter(Boolean);
    if (!entries.length) return;

    root.querySelectorAll('[data-pdp-sheet-benefits]').forEach(target => {
      const list = target.querySelector('.selling-points__list');
      if (!list) return;
      const fragment = document.createDocumentFragment();
      entries.forEach(text => {
        const item = document.createElement('li');
        item.textContent = text;
        fragment.appendChild(item);
      });
      list.replaceChildren(fragment);
      list.classList.toggle('two-col', entries.length > 4);
      target.hidden = false;
    });
  }

  async function hydrate(root) {
    if (hydrated.has(root) || pending.has(root)) return;
    const handle = root.dataset.pdpProductHandle;
    const url = root.dataset.pdpDatabaseUrl;
    if (!handle || !url) return;

    pending.add(root);
    try {
      const database = await loadDatabase(url);
      if (!root.isConnected) return;
      const product = database.products && database.products[handle];
      const importedFields = database.metadata && database.metadata.sheet_import &&
        database.metadata.sheet_import.fields_by_handle && database.metadata.sheet_import.fields_by_handle[handle];
      if (!product || !Array.isArray(importedFields)) return;

      // Blank sheet cells must preserve native product copy, even if older database copy exists.
      if (importedFields.includes('description')) updateDescription(root, product.description);
      if (importedFields.includes('benefits')) updateBenefits(root, product.benefits);
      hydrated.add(root);
    } catch (error) {
      // The server-rendered Shopify content remains usable if the asset cannot be loaded.
    } finally {
      pending.delete(root);
    }
  }

  function refresh(scope) {
    if (scope.matches && scope.matches(ROOT_SELECTOR)) hydrate(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(ROOT_SELECTOR).forEach(hydrate);
  }

  window.SebiPdpSheetContent = { refresh };
  document.addEventListener('shopify:section:load', event => refresh(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refresh(document), { once: true });
  } else {
    refresh(document);
  }
})();
